const pagesDeviceProfileMdmEn = {
  emptyState: {
    title: "No MDM software integrated.",
    description:
      "Connect your MDM software (Intune or LANSCOPE) to view device management information here.",
    action: "Add integration",
  },
};

export default pagesDeviceProfileMdmEn;
